const elementIsInArray = (array, element) => {
  return array && array.indexOf(element) >= 0
}

const getLastElementFromArray = (list) => {
  return list && list.length > 0 && list[list.length - 1]
}

export { elementIsInArray, getLastElementFromArray }
